
































import {Component, Prop, Vue} from 'vue-property-decorator'
import DataSpecsFormItems from "@/component/Thing/data-specs-form-items.vue";
import ParamProxy, {ParamBindProxy, ParamStdProxy, ProxyMode} from "@/module/thing/ParamProxy"
import thingModelModule from "@/store/module/ThingModelModule";
import {TabPane} from "element-ui";
import ParamStdProxyFormItems from "@/component/Thing/param-std-proxy-form-items.vue";
import ParamBindProxyFormItems from "@/component/Thing/param-bind-proxy-form-items.vue";
import ierror from "tools-ts/src/error/InnerError";

@Component({
  components: {
    DataSpecsFormItems,
    ParamStdProxyFormItems,
    ParamBindProxyFormItems
  },
})
export default class AddParamDialog extends Vue {
  @Prop() title!: string
  private paramStdProxy = new ParamStdProxy()
  private paramBindProxy = new ParamBindProxy()
  private paramProxy: ParamProxy = this.paramStdProxy

  private ProxyMode = ProxyMode
  private visible = false

  private thingModelModule = thingModelModule

  private activeProxyMode = ProxyMode.STD_PROXY

  open() {
    this.reset()
    this.visible = true
  }

  reset() {
    this.paramStdProxy = new ParamStdProxy()

    const firstProp = thingModelModule.thingModel.properties[0]
    this.paramBindProxy = ParamBindProxy.of(firstProp)

    this.changeParamProxy(this.activeProxyMode)
  }

  close() {
    this.visible = false
  }

  handleTabsClick(tabPane: TabPane) {
    const mode = tabPane.name as ProxyMode
    if (mode != this.activeProxyMode) {
      this.changeParamProxy(mode)
      this.activeProxyMode = mode
    }
  }

  changeParamProxy(mode: ProxyMode = this.activeProxyMode) {
    switch (mode) {
      case ProxyMode.STD_PROXY:
        this.paramProxy = this.paramStdProxy
        break
      case ProxyMode.BIND_PROXY:
        this.paramProxy = this.paramBindProxy
        break
      default:
        ierror(`未知参数代理类型: ${mode}`)
    }
  }

  confirm() {
    this.$emit('confirm', this.getParamProxy())
    this.close()
  }

  getParamProxy() {
    this.changeParamProxy()
    return this.paramProxy
  }
}
